import Placeholder from '../components/ui/Placeholder.jsx'

export default function Splash() {
  return (
    <Placeholder
      screen="Splash"
      purpose="First frame while auth state resolves. Shows the ZIvapp logo."
    />
  )
}
